import { combineReducers } from '@reduxjs/toolkit';

import userSlice from './user';
import cruiseSlice from './cruise';
import flightSlice from './flight';
import hotelSlice from './hotel';
import tripSlice from './trip';
import carSlice from './car';
import tripSearchSlice from './tripSearch';
import intelligenceSlice from './intelligence';
import brochureSlice from './brochure';
import scrollSlice from './scroll';
import compareSlice from './compare';
import callbackSlice from './callback';
import autocompleteSlice from './autocomplete';
import customerSlice from './customer';
import tourSlice from './tour';
import customInventorySlice from './customInventory';
import insuranceSlice from './insurance';
import userLocalPreferencesSlice from './userLocalPreferences';
import walletSlice from './wallet';

const rootReducer = combineReducers({
  user: userSlice,
  cruise: cruiseSlice,
  flight: flightSlice,
  hotel: hotelSlice,
  trip: tripSlice,
  tour: tourSlice,
  car: carSlice,
  intelligence: intelligenceSlice,
  brochure: brochureSlice,
  scroll: scrollSlice,
  compare: compareSlice,
  callback: callbackSlice,
  tripSearch: tripSearchSlice,
  autocomplete: autocompleteSlice,
  customer: customerSlice,
  customInventory: customInventorySlice,
  insurance: insuranceSlice,
  userLocalPreferences: userLocalPreferencesSlice,
  wallet: walletSlice,
});

export default rootReducer;
